'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateRating = calculateRating;

var _constants = require('../constants');

var _config = require('../config');

function compose() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return fns.reduce(function (f, g) {
    return function () {
      return f(g.apply(undefined, arguments));
    };
  });
}

function addInPolygon(estb) {
  var searchPolygon = (0, _config.getConfig)('SEARCH_POLYGON');
  if (estb.polygons && ~estb.polygons.indexOf(searchPolygon)) {
    estb.computedRating += _constants.RATING.POLYGON_FACTOR;
  }
  return estb;
}

function addCPC(estb) {
  if (estb.cheapestPartner) {
    var PARTNERS = (0, _config.getConfig)('PARTNERS');

    estb.computedRating += PARTNERS[estb.cheapestPartner].cpc * _constants.RATING.CPC_FACTOR;
  }
  return estb;
}

function addRangePrices(estb) {

  var RATING_PRICES_RANGE = (0, _config.getConfig)('RATING_PRICES_RANGE');

  if (estb.minDayPrice) {
    if (estb.minDayPrice < RATING_PRICES_RANGE.MIN) {
      estb.computedRating += _constants.RATING.PRICE_FACTOR * estb.minDayPrice / RATING_PRICES_RANGE.MIN;
    } else if (estb.minDayPrice > RATING_PRICES_RANGE.MAX) {
      estb.computedRating += _constants.RATING.PRICE_FACTOR * Math.max((RATING_PRICES_RANGE.MAX - estb.minDayPrice + 50) / 50, 0);
    } else {
      estb.computedRating += _constants.RATING.PRICE_FACTOR;
    }
  }
  return estb;
}

function addDiscount(estb) {
  if (estb.discount && estb.discount < _constants.RATING.MAX_DISCOUNT) {
    estb.computedRating += _constants.RATING.DISCOUNT_FACTOR * (1 - estb.minDayPrice / estb.maxDayPrice);
  }
  return estb;
}

function addInstantBooking(estb) {
  if (estb.availability === _constants.AVAILABILITY.INSTANTLY) {
    estb.computedRating += _constants.RATING.INSTANTBOOKING_FACTOR;
  }
  return estb;
}

function addNumberPrices(estb) {
  var numberPrices = estb.partners.filter(function (partner) {
    return partner.price_per_day;
  }).length;

  estb.computedRating += numberPrices * _constants.RATING.NUMBER_PRICES_FACTOR;
  return estb;
}

function addQualityScore(estb) {
  var qualityScore = estb.qualityScore || 0;
  var qualityScoreFactor = _constants.RATING.QUALITY_SCORE[estb.cheapestPartner] || 0;
  estb.computedRating += qualityScore * qualityScoreFactor;
  return estb;
}

function addCancellationPolicy(estb) {
  if (estb.cancellationPolicy && estb.cancellationPolicy === _constants.CANCELLATION_POLICY.FULL) {
    estb.computedRating += _constants.RATING.CANCELLATION_POLICY;
  }
  return estb;
}

function addBoosting(estb) {
  var culture = (0, _config.getConfig)('DOMAIN_CULTURE');
  if (culture === 'it-it' && global.isPhone && _constants.HOTEL_CATEGORIES.includes(estb.partners[0].partner_id)) estb.computedRating += _constants.RATING.BOOKING_BOOST;
  return estb;
}

function calculateRating(estb) {
  estb.computedRating = estb.rating;
  return compose(addInPolygon, addCPC, addRangePrices, addDiscount, addInstantBooking, addNumberPrices, addQualityScore, addCancellationPolicy, addBoosting)(estb);
}